// Articoli del blog in inglese — per le coppie internazionali che si sposano sul Lago di Lugano
export const articlesEn = [
  {
    slug: "choose-wedding-dj-ticino",
    title: "How to Choose a Wedding DJ in Ticino | DJ Magix",
    description:
      "Choosing a wedding DJ in Ticino and Lake Lugano: experience, equipment, repertoire and price. The 6 checks to make before you book.",
    h1: "How to Choose the DJ for Your Wedding in Ticino",
    date: "2026-10-16",
    image: "/assets/matrimonio2.webp",
    excerpt:
      "Experience, equipment, repertoire and quote: the 6 checks to make before booking your wedding in Ticino.",
    itSlug: "scegliere-dj-matrimonio-ticino",
    blocks: [
      {
        text: "The DJ can turn your wedding into an unforgettable party — or an evening with an empty dancefloor. After 25 years of weddings in Ticino, here are the 6 checks I recommend every couple make before signing.",
      },
      {
        h2: "1. Real experience, not just a playlist",
        text: "A wedding is not a club night: there are grandparents, children, friends and colleagues. You need a DJ who can read the floor and move from a slow dance to 80s/90s revival without losing anyone. Always ask how many weddings they have done, not just how many club nights.",
      },
      {
        h2: "2. Own equipment and a plan B",
        text: "A professional arrives with their own sound and lighting rig, wireless microphones for speeches and ceremony, and a backup plan in case of failure. If the venue has to rent the equipment separately, the final cost rises and responsibility gets fragmented.",
      },
      {
        h2: "3. A proper briefing and a tailor-made playlist",
        text: "Be wary of anyone who asks you nothing. A good DJ wants to know: your favourite songs, the genres to avoid, the key moments (entrance, first dance, cake cutting) and the profile of your guests. The playlist is built together, weeks in advance.",
      },
      {
        h2: "4. A clear, written quote",
        text: "The quote should state hours of service, equipment included, travel and any extras such as cold sparks or karaoke. At DJ Magix prices start from CHF 150, and the quote is always free and non-binding.",
      },
      {
        h2: "5. Reviews and videos of real events",
        text: "Photos and videos of real weddings are worth more than a thousand words. Check the DJ's social channels, ask for references and make sure the reviews talk about weddings, not just nightclub nights.",
      },
      {
        h2: "6. The right chemistry",
        text: "The DJ will be the voice of your wedding: they must understand you instantly and put you at ease. If the connection doesn't spark at the first meeting — even just a phone call — keep looking. Want to talk it over? Message me on WhatsApp: I reply personally.",
      },
    ],
  },
  {
    slug: "dj-cost-switzerland",
    title: "How Much Does a DJ Cost in Switzerland? 2026 Prices | DJ Magix",
    description:
      "How much does a DJ cost for a wedding or party in Switzerland? What drives the price, what a proper quote must include and how to compare offers.",
    h1: "How Much Does a DJ Cost in Switzerland? A Guide to Prices",
    date: "2026-10-16",
    image: "/assets/gallery1.webp",
    excerpt:
      "Price ranges, what a serious quote includes and the factors that push the cost of a DJ in Switzerland up (or down).",
    itSlug: "costo-dj-svizzera",
    blocks: [
      {
        text: "It's the question I get asked most often: how much does a DJ cost for a wedding or a party? The honest answer is: it depends. In Switzerland, prices typically range from a few hundred francs for a simple private party to over a thousand for a full wedding with effects. Here's how to find your way.",
      },
      {
        h2: "What influences the price",
        text: "Five factors decide the final cost:",
        list: [
          "Duration: a 2-hour aperitif or a party until 4 a.m. do not cost the same",
          "Travel: an event in Ticino versus one in Zurich or Geneva involves different logistics",
          "Equipment: a rig for 50 guests in a living room or sound and lights for 1000 people in a square",
          "Special effects: cold sparks, laser show, professional karaoke",
          "The date: weekends between May and September are the most in demand",
        ],
      },
      {
        h2: "What a good quote must include",
        text: "Hours of service, setup and teardown, sound and lighting rig, microphones, a preparation meeting and a personalised playlist. If an item is missing, ask: extras discovered at the last minute are the main source of misunderstandings.",
      },
      {
        h2: "DJ Magix pricing",
        text: "My services start from CHF 150, with a free, written and non-binding quote. Sound and lighting equipment is always included, with travel across Ticino and up to 200 km (Zurich, Geneva, Bern, Basel, Northern Italy). Tell me about your event via the quote form or on WhatsApp and you'll receive a tailor-made proposal.",
      },
    ],
  },
];
